import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import DashboardCard from "../DashboardCard";

import { displayPercentage, displayData } from "../../../utils/data";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  total: {
    backgroundColor: colors.greyDoughnut,
    width: "110px",
    maxWidth: "110px",
    height: "67px",
    margin: "-16px 30px -16px -8px",
    padding: "7px",
    overflowWrap: "break-word",
  },
  title: {
    color: colors.black87,
    fontWeight: 500,
    textAlign: "center",
    lineHeight: "16px",
    fontSize: "1.1em",
    marginBottom: "5px",
  },
  categoryContainer: {
    width: "150px",
    paddingTop: "6px",
  },
  iconContainer: {
    "&img": {
      maxWidth: "40px",
      maxHeight: "24px",
    },
  },
  legendValue: {
    fontWeight: 500,
    fontSize: "2em",
    lineHeight: "30px",
  },
  legendPercentage: {
    color: colors.black87,
    marginLeft: "12px",
    fontSize: "1.142em",
  },
  valueLine: {
    display: "flex",
    alignItems: "flex-end",
  },
};

const MdcTotalActiveProfiles = (props) => {
  const { classes, data } = props;

  const total = get(data, [
    "misc",
    "total_number_of_profiles",
    "total_number_of_profiles",
  ]);
  const humans = get(data, [
    "misc",
    "total_number_of_profiles",
    "number_of_humans",
  ]);
  const vehicles = get(data, [
    "misc",
    "total_number_of_profiles",
    "number_of_vehicles",
  ]);
  const trailers = get(data, [
    "misc",
    "total_number_of_profiles",
    "number_of_trailers",
  ]);
  const containers = get(data, [
    "misc",
    "total_number_of_profiles",
    "number_of_containers",
  ]);

  return (
    <DashboardCard size={"924px"} style={{ marginLeft: "12px" }}>
      <Grid
        container
        alignItems="center"
        wrap="nowrap"
        style={{ height: "100%" }}
      >
        <Grid item className={classes.total}>
          <Grid container direction="column" alignItems="center">
            <Grid item className={classes.title}>
              {I18n.get("dashboard_profilesSelected")}
            </Grid>
            <Grid item className={classes.legendValue}>
              {displayData(total)}
            </Grid>
          </Grid>
        </Grid>
        {map(
          [
            {
              value: humans,
              icon: images.humanIconBlack,
              percentage: Math.round((humans / total) * 100),
            },
            {
              value: vehicles,
              icon: images.truckIconBlack,
              percentage: Math.round((vehicles / total) * 100),
            },
            {
              value: trailers,
              icon: images.trailerIconBlack,
              percentage: Math.round((trailers / total) * 100),
            },
            {
              value: containers,
              icon: images.containerIconBlack,
              percentage: Math.round((containers / total) * 100),
            },
          ],
          (item, index) => (
            <Grid item key={index} className={classes.categoryContainer}>
              <Grid container direction="column">
                <Grid
                  item
                  className="flexCenter"
                  style={{ minHeight: "30px", maxHeight: "30px" }}
                >
                  <img
                    src={item.icon}
                    style={{ maxHeight: "30px", maxWidth: "45px" }}
                    alt="icon"
                  />
                </Grid>
                <Grid item className={classes.valueLine}>
                  <Box
                    component="span"
                    className={clsx("text-87", classes.legendValue)}
                  >
                    {displayData(item.value)}
                  </Box>
                  <Box component="span" className={classes.legendPercentage}>
                    {displayPercentage(item.percentage)}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          )
        )}
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(MdcTotalActiveProfiles);
